import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import React, { Component, Children, cloneElement } from 'react';
import StackView from '../StackView';
export var TABLIST_DISPLAY_NAME = 'TabList';

var TabList = /*#__PURE__*/function (_Component) {
  _inheritsLoose(TabList, _Component);

  function TabList() {
    return _Component.apply(this, arguments) || this;
  }

  var _proto = TabList.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        activeIndex = _this$props.activeIndex,
        axis = _this$props.axis,
        children = _this$props.children,
        id = _this$props.id,
        moveTabFocus = _this$props.moveTabFocus,
        setActiveIndex = _this$props.setActiveIndex,
        restProps = _objectWithoutPropertiesLoose(_this$props, ["activeIndex", "axis", "children", "id", "moveTabFocus", "setActiveIndex"]);

    var backwardKey = axis === 'horizontal' ? 'ArrowLeft' : 'ArrowUp';
    var forwardKey = axis === 'horizontal' ? 'ArrowRight' : 'ArrowDown';
    return /*#__PURE__*/React.createElement(StackView, _extends({
      role: "tablist",
      "aria-orientation": axis,
      axis: axis,
      distribution: "fill"
    }, restProps), Children.map(children, function (child, index) {
      return /*#__PURE__*/cloneElement(child, {
        axis: axis,
        id: id + "-" + index,
        isActive: index === activeIndex,
        tabIndex: child.props.disabled ? undefined : index !== activeIndex ? -1 : 0,
        onFocus: function onFocus() {
          return setActiveIndex(index);
        },
        onKeyDown: function onKeyDown(event) {
          if (event.key === backwardKey) {
            event.preventDefault();
            moveTabFocus(-1);
          }

          if (event.key === forwardKey) {
            event.preventDefault();
            moveTabFocus(1);
          }

          if (event.key === 'Home') {
            event.preventDefault();
            moveTabFocus(0);
          }

          if (event.key === 'End') {
            event.preventDefault();
            moveTabFocus(Children.count(children) - 1);
          }
        }
      });
    }));
  };

  return TabList;
}(Component);

_defineProperty(TabList, "displayName", TABLIST_DISPLAY_NAME);

_defineProperty(TabList, "defaultProps", {
  axis: 'horizontal'
});

export default TabList;